import entitlementManagement from './entitlementManagement';
import billing from './billing';
import eTrack from './eTrack';
import setup from './setup';
import userSetup from './useSetup';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [entitlementManagement, eTrack, billing, setup, userSetup]
};

export default menuItems;
